import React from 'react';
import { MdSearch as IconSearch } from 'react-icons/md';
import { withRouter } from 'react-router-dom';
import { Button, Form, FormGroup, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { SizeMe } from 'react-sizeme';

/* Material-ui */
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

/* Tooltip */
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

/* Routes */
import { domainIsTenant as dit, S, domain } from '../../routes/routes'

/* Object Json */
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';
import { isNone } from 'iotera-base/object';
import Result from 'iotera-base/result';

import { SubViewHeader } from '../../lib/components/subHeader';
import { RulesTable } from '../../custom/table';
import IoteraClass from '../../lib/components/react/react-class';
import { ioteraConfirmAlert } from '../../lib/components/react/react-confirm-alert';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const INIT_RULES = 'INIT_RULES';
const CONTROL_ACTIVATE = "CONTROL_ACTIVATE";
const DELETE = "DELETE"
const WKEY = 'RULE_LIST';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

class RulesCard extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      operation: false,
      search: "",
      filter: false,
      ruleList: props.data,
      filters: {
        deviceType: [],
        location: [],
        sensors: [],
        components: [],
        status: []
      },
      custom: window.innerWidth <= 768 ? "col-md-6" : "col-md-5"
    }
    this.resize = this.resize.bind(this);
  }

  resize(event) {
    setTimeout(this.setState({
      custom: window.innerWidth <= 768 ? "col-md-6" : "col-md-5"
    }), 1000)
  }

  componentDidMount() {
  }

  handleChange = event => {
    this.setState({ search: event.target.value })
  }

  handleKeyUp = event => {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { search } = _state
    if (event.key === "Enter") {
      _this.handleSearchFilter()
    }
    if (((event.key === "Backspace") || (event.key === "Delete")) && search.length === 0) {
      _this.setState({ ruleList: _props.data });
    }
  }

  handleSearchFilter = () => {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    let newState = Object.assign({}, _state);
    let rules = []
    let { search } = _state
    _props.data.forEach((rule) => {
      let foundRule = (search === '') || ((rule.name.toLowerCase().search(search.toLowerCase())) !== -1)
      if (foundRule) {
        rules.push(rule)
      }
    })
    newState.ruleList = rules
    _this.setState({ ruleList: rules, filter: true });
    if (_state.search.length === 0) {
      _this.setState({ ruleList: _props.data });
    }
  }

  submitHandler(e) {
    e.preventDefault();
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { filter, ruleList, search } = _state
    window.onresize = this.resize;
    let data = safeDeepGet(_props, ['data'], []);
    if (filter) {
      data = ruleList
    }
    const length = data.length;
    const finalData = safeDeepGet(_props, ['finalData']);
    if (finalData) {
      return (
        <div>
          <Form onSubmit={_this.submitHandler}>
            <FormGroup row>
              <div className="col-md-12" style={{ paddingTop: '6px' }}>
                <InputGroup>
                  <Input placeholder="Cari berdasarkan nama rule" value={search}
                    onChange={_this.handleChange} onKeyUp={_this.handleKeyUp} type="text" step="1" />
                  <InputGroupAddon addonType="append"><Button onClick={_this.handleSearchFilter}>
                    <IconSearch size={16} /></Button>
                  </InputGroupAddon>
                </InputGroup>
              </div>
            </FormGroup>
            {length > 0 ?
              <SizeMe>{({ size }) =>
                < div className="table-responsive">
                  <RuleListTableWR data={data} tableSize={size} handleDelete={_props.handleDelete}
                    handleChangeStatus={_props.handleChangeStatus} />
                </div>
              }</SizeMe>
              :
              <div className="col-md-12" style={{ paddingTop: '6px' }}>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Oopss... rule tidak ditemukan</div>
              </div>
            }
          </Form>
        </div >
      )
    } else {
      return (
        <div>
          <Form onSubmit={_this.submitHandler}>
            <FormGroup row>
              <div className="col-md-12" style={{ paddingTop: '6px' }}>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Oopss... Rule Masih Kosong</div>
                <div style={{ textAlign: 'center' }}>Daftar rule yang telah dibuat akan ditampilkan disini.</div>
              </div>
            </FormGroup>
          </Form>
        </div>
      )
    }
  }
}

const RuleListTableWR = withRouter(RulesTable);

class Rules extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    }
    this.handleClick = this.handleClick.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
  }

  handleDelete(deviceId) {
    this.props.wSingleRequestCall({
      id: DELETE,
      body: {
        id: deviceId
      }
    })
  };

  componentWillReceiveProps(nextProps) {
    const _this = this;
    const _props = _this.props
    if (nextProps.location !== _props.location) {
      _this.setState({ prevPath: _props.location })
    }
  }

  handleClick() {
    const _props = this.props
    ioteraConfirmAlert(
      'Konfirmasi',
      'Tambah manual atau dengan editor?',
      'Editor',
      'disable', /*function or string 'disable' to disable right/yes button*/
      'Manual',
      () => {
        _props.history.push('.' + S + '_rule_add_') /*function or string 'disable' to disable left/no button*/
      }
    );
  };

  handleChangeStatus = (id, value) => {
    this.props.wSingleRequestCall({
      id: CONTROL_ACTIVATE,
      body: {
        id,
        active: value
      }
    });
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const domainIsTenant = dit(_props);
    const domains = domain(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: "/service/web/rule/list" },
        wcallback: {
          started: function (id) {
            // TODO Loading
          },
          finished: function (id, result) {
            // TODO Loading
            _this.setState({
              loading: false
            })
          }
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [CONTROL_ACTIVATE]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/rule/activate"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({ loading: false })
                  // Magic to refresh routes
                  _props.history.push('..')
                  _props.history.push('..' + S + domains + S + '_rule_list_')
                  _props.showSingleNotification({ message: 'Ubah status rule berhasil', level: 'success' });
                  return;
                }
              }
            }
          }
        },
        [DELETE]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/rule/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false
                  })
                  _props.history.push('..')
                  _props.history.push('..' + S + domains + S + '_rule_list_')
                  _props.showSingleNotification({ message: 'Hapus rule berhasil', level: 'success' });
                  return;
                }
              }
              _this.setState({
                loading: false
              })
              _props.showSingleNotification({ message: 'Hapus rule gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    let rule = safeDeepGet(_props, ['items'], {});
    let data = safeDeepGet(rule, ['data'], [])
    let { loading } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    let finalData = false;
    if (!isNone(data)) {
      if (data.length > 0) {
        finalData = true;
      }
    }
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Rule' subTitle='Seluruh rule yang terdaftar di aplikasi ini.' />
          <div className="view-content-dashboard">
            <RulesCard {..._props} data={data} finalData={finalData} handleDelete={_this.handleDelete}
              handleChangeStatus={_this.handleChangeStatus} />
            <Tooltip TransitionComponent={Zoom} title='Tambah Rule' enterDelay={500} >
              <Fab variant="extended" color={'primary'} style={{
                position: 'absolute',
                bottom: 0 * 2,
                right: 20 * 2
              }}
                onClick={(e) => _this.handleClick(e)}
              >
                <AddIcon style={{ marginRight: 8 }} />
                Rule Baru
              </Fab>
            </Tooltip>
          </div>
        </div>
      </Loader >
    )
  }
}

const mapStateToProps = function (state) {
  return {
    items:
    {
      data: wSelector.getSoleInitMappedRPayload(state, 'rules')
    }
  }
};

const mapDispatchToProps = (dispatch) => ({
  ...wBoundActions(dispatch),
  ...bindActionCreators(notificationActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Rules));